
export const useRequestTable = () => {
    const getStatusLabel = (status: string) => {
        switch (status) {
            case 'pending':
                return 'Pendiente'
            case 'approved':
                return 'Aprobada'
            case 'rejected':
                return 'Rechazada'
            case 'pendingpayment':
                return 'Fichas Bajadas - Pendiente De Pago'
            default:
                return 'Pendiente'
        }
    }

    const getStatusColor = (status: string) => {
        switch (status) {
            case 'pending':
                return 'text-warning'
            case 'approved':
                return 'text-success'
            case 'rejected':
                return 'text-danger'
            case 'pendingpayment':
                return 'text-warning'
            default:
                return 'text-secondary'
        }
    }

    const getTypeLabel = (type: string) => {
        switch (type) {
            case 'load':
                return 'Carga'
            case 'withdraw':
                return 'Retiro'
            default:
                return type
        }
    }

    const getTypeColor = (type: string) => {
        switch (type) {
            case 'load':
                return 'text-success'
            case 'withdraw':
                return 'text-danger'
            default:
                return 'text-secondary'
        }
    }



    return {
        getStatusLabel,
        getStatusColor,
        getTypeLabel,
        getTypeColor,
    }
}
